import React from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {Box, Typography} from "@material-ui/core";
import clsx from "clsx";
import CheckCircleIcon from "@material-ui/icons/CheckCircleOutlineTwoTone";
import useStyles from "./styles";

type StepHeaderProps = {
  text: string;
  isChosen?: boolean;
  isComplete?: boolean;
  isLast?: boolean;
  orderNumber?: number;
  textClassName?: string;
};

function StepHeader({
  text,
  isComplete,
  isChosen,
  isLast,
  orderNumber,
  textClassName,
}: StepHeaderProps) {
  const classes = useStyles();
  const IncompleteStep = () => (
    <FlexBox gap={1} alignCenter>
      {!!orderNumber && (
        <FlexBox
          alignCenter
          justifyCenter
          className={clsx(
            classes.headerNumber,
            textClassName,
            isChosen && classes.chosenHeaderNumber
          )}
        >
          <Typography variant="h4">{orderNumber}</Typography>
        </FlexBox>
      )}
      <Typography
        className={clsx(
          classes.header,
          textClassName,
          isChosen && classes.chosenHeader
        )}
      >
        {text}
      </Typography>
    </FlexBox>
  );
  const CompleteStep = () => (
    <FlexBox gap={1} alignCenter>
      <CheckCircleIcon htmlColor="grey" />
      <Typography className={clsx(classes.header, textClassName)}>
        {text}
      </Typography>
    </FlexBox>
  );
  return (
    <FlexBox gap={1.5} alignCenter flexGrow={isLast ? 0 : 1}>
      {isComplete ? <CompleteStep /> : <IncompleteStep />}
      {!isLast && <Box className={classes.divider} />}
    </FlexBox>
  );
}

export default StepHeader;
